<template>
  <v-container v-if="$store.state.menu.Dealers" fill-height fluid grid-list-xl>
    <Loader :loading="loading" />

    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="green"
          title="Рейтинг дилеров"
          :text="total + ' диллеров'"
        >
          <v-btn
            color="primary"
            small
            class="mr-2"
            @click="getDealers(false)"
            text
            >Обновить</v-btn
          >

          <v-btn
            color="warning"
            small
            class="mr-2"
            @click="openFilter = !openFilter"
            text
            >Календарь</v-btn
          >

          <v-btn @click="clearRange" small color="danger" class="mr-2" text
            >Сбросить</v-btn
          >

          <v-btn @click="openExport" small color="danger" text
            >Экспорт excel</v-btn
          >

          <v-radio-group v-model="isActiveSet">
            <v-layout>
              <v-flex>
                <v-radio
                  @change="setResource"
                  label="Показать всех"
                  color="primary"
                  value="0"
                ></v-radio>
              </v-flex>

              <v-flex>
                <v-radio
                  @change="setResource"
                  label="Показать  активные"
                  color="primary"
                  value="1"
                ></v-radio>
              </v-flex>

              <v-flex>
                <v-radio
                  @change="setResource"
                  label="Показать  не активные"
                  color="primary"
                  value="2"
                ></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>

          <v-radio-group v-model="isWithdrawSet">
            <v-layout>
              <v-flex>
                <v-radio
                  @change="setResource"
                  label="С учетом вывода и начислений"
                  color="primary"
                  :checked="true"
                  value="0"
                ></v-radio>
              </v-flex>

              <v-flex>
                <v-radio
                  @change="setResource"
                  label="Только начисление"
                  color="primary"
                  value="1"
                ></v-radio>
              </v-flex>
              <!-- 
              <v-flex>
                <v-radio
                  @change="setResource"
                  label="Только вывод"
                  color="primary"
                  value="2"
                ></v-radio>

              </v-flex> -->
            </v-layout>
          </v-radio-group>

          <v-layout wrap>
            <v-flex sm12 xs12 md4 style="border: 5px solid transparent">
              <multiselect
                v-model="regionSelected"
                :options="region"
                :multiple="true"
                placeholder="Фильтр по региону"
                track-by="id"
                label="title"
                @input="setRegion"
              >
                <span slot="noResult">Нет такой категории</span>
              </multiselect>
            </v-flex>

            <v-flex sm12 xs12 md4 style="border: 5px solid transparent">
              <multiselect
                v-model="citySelected"
                :options="city"
                :multiple="true"
                :disabled="!city.length"
                placeholder="Фильтр по городу (району)"
                track-by="id"
                label="title"
                @input="setCity"
              >
                <span slot="noResult">Нет такой категории</span>
              </multiselect>
            </v-flex>

            <v-flex sm12 xs12 md4 style="border: 5px solid transparent">
              <multiselect
                v-model="outletSelected"
                :options="outlet"
                :multiple="true"
                :disabled="!outlet.length"
                placeholder="Фильтр по торговой точке"
                track-by="id"
                label="title"
                @input="setOutlet"
              >
                <span slot="noResult">Нет такой категории</span>
              </multiselect>
            </v-flex>
          </v-layout>

          <div>
            <v-radio-group v-model="countDay" @change="year = null">
              <v-layout>
                <v-flex>
                  <v-radio label="Неделя" color="primary" value="6"></v-radio>
                </v-flex>

                <v-flex>
                  <v-radio label="Месяц" color="primary" value="29"></v-radio>
                </v-flex>

                <v-flex>
                  <v-radio label="Квартал" color="primary" value="89"></v-radio>
                </v-flex>

                <v-flex>
                  <v-radio label="Год" color="primary" value="365"></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>
          </div>
          <div v-if="countDay == 6" class="week">
            <v-radio-group v-model="year">
              <v-layout>
                <v-flex v-for="(year, index) in years" :key="index">
                  <v-radio
                    :label="year"
                    color="primary"
                    :value="year"
                  ></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>

            <v-radio-group
              v-if="year"
              v-model="week_number"
              @change="getPeriodWeek"
            >
              <div class="filter-item">
                <div class="filter-item-radio" v-for="week in 52" :key="week">
                  <v-radio
                    :label="week + ' неделя'"
                    color="primary"
                    :value="week"
                  ></v-radio>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div v-if="countDay == 29" class="month">
            <v-radio-group v-model="year">
              <v-layout>
                <v-flex v-for="(year, index) in years" :key="index">
                  <v-radio
                    :label="year"
                    color="primary"
                    :value="year"
                  ></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>

            <v-radio-group v-if="year" v-model="month" @change="setFilter">
              <div class="filter-item">
                <div class="filter-item-radio" v-for="month in 12" :key="month">
                  <v-radio
                    :label="month | month"
                    color="primary"
                    :value="month"
                  ></v-radio>
                </div>
              </div>
            </v-radio-group>
          </div>

          <div v-if="countDay == 89" class="quarter">
            <v-radio-group v-model="year">
              <v-layout>
                <v-flex v-for="(year, index) in years" :key="index">
                  <v-radio
                    :label="year"
                    color="primary"
                    :value="year"
                  ></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>

            <v-radio-group v-if="year" v-model="quarter" @change="setFilter">
              <div class="filter-item">
                <div class="filter-item-radio" v-for="q in 4" :key="q">
                  <v-radio
                    :label="q + ' квартал'"
                    color="primary"
                    :value="q"
                  ></v-radio>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div v-if="countDay == 365" class="year">
            <v-radio-group v-model="year">
              <v-layout>
                <v-flex v-for="(year, index) in years" :key="index">
                  <v-radio
                    :label="year"
                    color="primary"
                    :value="year"
                  ></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>
          </div>

          <div v-if="start_at || end_at">
            <br />
            <span v-if="start_at">
              <b>С</b>
              {{ (start_at + " 00:00:00") | dateTime }}
            </span>
            <span v-if="end_at">
              <b>ДО</b>
              {{ (end_at + " 23:59:59") | dateTime }}
            </span>
          </div>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск..."
            class="sticky search"
            :loading="loadingSearch"
            single-line
            hide-details
            clearable="true"
          ></v-text-field>

          <v-data-table :headers="headers" :items="dealersList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item, index }">
              <td class="text-xs-left">{{ item.id }}</td>
              <td class="text-xs-left">
                <div v-text="rate(index)"></div>
              </td>
              <td class="text-xs-left min-width">{{ item.title }}</td>
              <td class="text-xs-left min-width">
                <span v-if="item.curator.length">{{
                  item.curator[0].name
                }}</span>
                <span v-else>Не установлен</span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.is_active" class="text-success">Активен</span>
                <span v-else class="error--text">Не активен</span>
              </td>

              <td class="text-xs-left">
                <span @click="SET_USER(item.id)" class="user-link">
                  {{ item.phone_number }}
                </span>
              </td>
              <td class="text-xs-left">{{ item.activations_count }}</td>
              <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
              <td class="text-xs-right">
                <b>{{ item.bonus | numberWithSpaces }} сум</b>
              </td>
            </template>
          </v-data-table>

          <div class="horizontal-scroll">
            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              total-visible="20"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </div>
        </material-card>
      </v-flex>
    </v-layout>

    <Dealer />

    <div :class="`products-filters ${openFilter ? ' activeNow' : ''}`">
      <div class="products-filters-content">
        <div class="products-filters-content-view date">
          <div>
            <!--<v-radio-group v-model="resourceValue">-->
            <!--<v-radio-->
            <!--v-if="resourceValue"-->
            <!--@change="setResource"-->
            <!--label="Показать все"-->
            <!--color="primary"-->
            <!--value="0"-->
            <!--&gt;</v-radio>-->
            <!--<v-radio-->
            <!--@change="setResource"-->
            <!--v-for="res in resources"-->
            <!--:label="res.name"-->
            <!--color="secondary"-->
            <!--:value="res.id"-->
            <!--&gt;</v-radio>-->
            <!--</v-radio-group>-->
            <div>
              <h4>ДАТА НАЧАЛА</h4>

              <v-date-picker
                :dark="true"
                v-model="start_at"
                :landscape="false"
                locale="ru"
                :color="'primary'"
                :reactive="true"
                :full-width="true"
                :show-current="false"
                :multiple="false"
                :readonly="false"
                :disabled="false"
                @change="setRange"
              ></v-date-picker>
            </div>
            <h4>ДАТА ОКОНАЧАНИЯ</h4>
            <div>
              <v-date-picker
                :dark="true"
                v-model="end_at"
                :landscape="false"
                locale="ru"
                :color="'primary'"
                :reactive="true"
                :full-width="true"
                :show-current="false"
                :multiple="false"
                :readonly="false"
                :disabled="false"
                @change="setRange"
              ></v-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="products-filters-control">
        <v-btn
          @click="clearRange"
          style="width: 100%"
          color="danger"
          class="mb-0"
          text
          >Сбросить все</v-btn
        >

        <v-btn
          style="width: 100%"
          color="primary"
          class="mb-0"
          @click="openFilter = false"
          text
          >Закрыть календарь</v-btn
        >
      </div>
    </div>

    <v-dialog
      width="400"
      persistent
      transition="dialog-bottom-transition"
      v-model="export_data.length && !loading"
    >
      <v-card>
        <v-card-text>
          <div class="body-2">Выгрузите экспорт</div>
          <br />
          <br />
          <download-excel
            v-if="export_data.length && loading === false"
            :data="export_data"
            :fields="json_fields_all_products"
            :name="'export_' + exportFileName"
          >
            <v-btn color="warning" text style="width: 100%">Скачать</v-btn>
          </download-excel>

          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn
            color="primary"
            text
            style="width: 100%"
            @click="export_data = []"
            >Закрыть</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loader from "../components/helper/Loader";
import Search from "../components/helper/Search";
import { mapMutations, mapState } from "vuex";
import Dealer from "../components/core/Dealer";

export default {
  data: () => ({
    //export

    //filters
    week_number: 0,
    year: 0,
    month: null,
    quarter: null,
    //end filters

    years: ["2019", "2020", "2021", "2022"],

    exportFileName: "",

    region: [],
    city: [],
    outlet: [],
    regionSelected: [],
    citySelected: [],
    outletSelected: [],
    json_fields_all_products: {
      "ID Дилера": "id",
      Дилер: "title",
      "Статус дилера": "is_active",
      "Номер телефона": "phone_number",
      "Позиция в рейтинге": "rate",
      "Количество активаций": "activations_count",
      "Количество бонусов (сум)": "bonus",
      Адрес: "address",
      "Торговая точка": "mark",
      "Дата регистрации": "created_at",
    },
    export_data: [],
    //export
    countDay: 0,
    search: "",
    start_at: null,
    end_at: null,
    openFilter: false,

    page: 1,
    total: 0,
    isActiveSet: 0,
    isWithdrawSet: 0,
    searcher: null,
    loadingSearch: true,
    last_page: 0,
    loading: true,
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "rate",
      },
      {
        sortable: false,
        text: "Рейтинг",
        value: "rate",
      },
      {
        sortable: false,
        text: "Диллер",
        value: "title",
      },
      {
        sortable: false,
        text: "Куратор",
        value: "title",
      },
      {
        sortable: false,
        text: "Статус",
        value: "title",
      },
      {
        sortable: false,
        text: "Телефон",
        value: "phone_number",
      },
      {
        sortable: false,
        text: "Количество активаций",
        value: "count_activation",
      },
      {
        sortable: false,
        text: "Дата регистрации",
        value: "count_activation",
      },
      {
        sortable: false,
        text: "Активных баллов",
        value: "bonus_total",
        align: "right",
      },
    ],
    dealersList: [],
  }),
  methods: {
    ...mapMutations(["SET_USER"]),

    openExport() {
      this.exportFileName = "dealers.xls";
      this.loading = true;

      setTimeout(() => {
        axios
          .get("admin/export/dealers", {
            params: {
              search: this.search,
              year: this.year,
              month: this.month,
              quarter: this.quarter,
              is_active: this.isActiveSet,
              without_withdrow: this.isWithdrawSet,
              start_at: this.start_at,
              end_at: this.end_at,
              region: this.selectedRegion,
              city: this.selectedCity,
              outlet: this.selectedOutlet,
            },
          })
          .then(async (response) => {
            this.export_data = await response.data;
          })
          .catch((error) => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          });
      }, 100);
    },
    getDealers(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/dealers-v2", {
          params: {
            per_page: 10,
            page: this.page,
            search: this.search,
            year: this.year,
            month: this.month,
            quarter: this.quarter,
            is_active: this.isActiveSet,
            without_withdrow: this.isWithdrawSet,
            start_at: this.start_at,
            end_at: this.end_at,
            //filter
            region: this.selectedRegion,
            city: this.selectedCity,
            outlet: this.selectedOutlet,
          },
        })
        .then((response) => {
          this.dealersList = response.data.data;
          this.total = response.data.total;
          this.last_page = response.data.last_page;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
        });
    },

    setResource() {
      setTimeout(() => {
        this.page = 1;
        this.getDealers(false);
      }, 400);
    },

    ////

    setRange() {
      this.page = 1;
      setTimeout(() => {
        this.getDealers();
      }, 300);
    },
    clearRange() {
      this.city =
        this.citySelected =
        this.outlet =
        this.outletSelected =
        this.regionSelected =
          [];
      this.page = 1;
      this.year = null;
      this.quarter = null;
      this.isActiveSet = 0;
      this.search = "";
      this.start_at = this.end_at = null;
      this.countDay = 0;
      setTimeout(() => {
        this.getDealers();
      }, 300);
    },
    setDay() {
      this.page = 1;
      setTimeout(() => {
        let now = new Date(Date.now());
        let today = this.setZero(now.getDate());
        let month = this.setZero(now.getMonth() + 1);
        let year = now.getFullYear();
        if (!this.countDay) {
          this.countDay = 0;
        }
        let endDate = Date.now() - this.countDay * 24 * 3600 * 1000;
        let startNow = new Date(endDate);
        let todayNow = this.setZero(startNow.getDate());
        let monthNow = this.setZero(startNow.getMonth() + 1);
        let yearNow = startNow.getFullYear();
        this.start_at = yearNow + "-" + monthNow + "-" + todayNow;
        this.end_at = year + "-" + month + "-" + today;
      }, 20);

      setTimeout(() => {
        this.getDealers();
      }, 300);
    },

    setZero(val) {
      if (val <= 9) {
        val = "0" + val;
      }
      return val;
    },
    //filter
    getRegion() {
      axios
        .get("admin/locations/list", {
          params: {},
        })
        .then((response) => {
          this.region = response.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },

    getPeriodWeek() {
      var fromDateDay = 1 + (this.week_number - 1) * 7;
      var fromDate = new Date(this.year, 0, fromDateDay);

      var tillDateDay = fromDateDay + (7 - fromDate.getDay());

      var tillDate = new Date(this.year, 0, tillDateDay);
      if (this.week_number == 53) {
        // 53 is last week of the year
        tillDate = fromDate;
        var isLeap = new Date(this.year, 1, 29).getMonth() == 1;
        if (isLeap) {
          tillDate = new Date(this.year, 0, fromDateDay + 1);
        }
      }

      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      (this.start_at =
        fromDate.getFullYear() +
        "-" +
        (fromDate.getMonth() + 1) +
        "-" +
        fromDate.getDate()),
        (this.end_at =
          tillDate.getFullYear() +
          "-" +
          (tillDate.getMonth() + 1) +
          "-" +
          tillDate.getDate());
      this.page = 1;

      this.getDealers();
    },

    setFilter() {
      this.page = 1;
      this.getDealers();
    },

    setRegion() {
      this.city = this.citySelected = this.outlet = this.outletSelected = [];
      axios
        .get("admin/locations/list", {
          params: {
            region: this.selectedRegion,
            is_city: 1,
          },
        })
        .then((response) => {
          this.city = response.data;
        })
        .catch((error) => {})
        .finally(() => {});

      this.page = 1;
      setTimeout(() => {
        this.getDealers();
      }, 100);
    },
    setCity() {
      this.outlet = this.outletSelected = [];
      axios
        .get("admin/locations/outlet", {
          params: {
            region: this.selectedRegion,
            city: this.selectedCity,
          },
        })
        .then((response) => {
          this.outlet = response.data;
        })
        .catch((error) => {})
        .finally(() => {});

      this.page = 1;
      setTimeout(() => {
        this.getDealers();
      }, 100);
    },
    setOutlet() {
      this.page = 1;
      setTimeout(() => {
        this.getDealers();
      }, 100);
    },
    rate(index) {
      let rate = 1;
      if (this.page > 1) {
        rate = (this.page - 1) * 10 + 1;
      }
      return rate + index;
    },
  },
  watch: {
    search() {
      this.page = 1;

      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getDealers(true);
      }, 1000);
    },
    year() {
      this.page = 1;
      this.week_number = 0;
      this.start_at = this.end_at = this.month = this.quarter = null;
      this.getDealers();
    },
    page() {
      setTimeout(() => {
        this.getDealers();
      }, 300);
    },
    badge() {
      setTimeout(() => {
        this.getDealers(true);
      }, 300);
    },
  },

  computed: {
    ...mapState(["badge"]),
    selectedRegion: {
      get() {
        if (this.regionSelected.length) {
          let region = [];
          for (let i = 0; i < this.regionSelected.length; i++) {
            region.push(this.regionSelected[i].id);
          }
          return region.length ? region.join("-") : "";
        }
        return "";
      },
    },
    selectedCity: {
      get() {
        if (this.citySelected.length) {
          let city = [];
          for (let i = 0; i < this.citySelected.length; i++) {
            city.push(this.citySelected[i].id);
          }
          return city.length ? city.join("-") : "";
        }
        return "";
      },
    },
    selectedOutlet: {
      get() {
        if (this.outletSelected.length) {
          let outlet = [];
          for (let i = 0; i < this.outletSelected.length; i++) {
            outlet.push(this.outletSelected[i].id);
          }
          return outlet.length ? outlet.join("-") : "";
        }
        return "";
      },
    },
  },
  components: { Dealer, Search, Loader },
  mounted() {
    this.getDealers();
    this.getRegion();
  },

  filters: {
    month: function (data) {
      data = data.toString();

      switch (data) {
        case "1": {
          return "Январь";
          break;
        }
        case "2": {
          return "Февраль";
          break;
        }
        case "3": {
          return "Март";
          break;
        }
        case "4": {
          return "Апрель";
          break;
        }
        case "5": {
          return "Май";
          break;
        }
        case "6": {
          return "Июнь";
          break;
        }
        case "7": {
          return "Июль";
          break;
        }
        case "8": {
          return "Август";
          break;
        }
        case "9": {
          return "Сентябрь";
          break;
        }
        case "10": {
          return "Октябрь";
          break;
        }
        case "11": {
          return "Ноябрь";
          break;
        }
        case "12": {
          return "Декабрь";
          break;
        }
        default: {
          return "Не найден";
          break;
        }
      }
    },
  },
};
</script>
